module.exports = __webpack_public_path__ + "img/sub3.268aa5a7.jpg";